import React from "react"
import Header from "../components/global/Header"
import Footer from "../components/global/Footer"
import user from "../assets/images/user.png"
import cart from "../assets/images/cart.png"

import messages from "../assets/images/messages.png"
import saved from "../assets/images/saveditems.png"

import userpic from "../assets/images/team-image.png"
import Map from "../assets/images/Map.png"


function UserDashboard() {

  return (
    <div>
      <Header />
      <div className=" board">
        <div className="container">
          <div className="row board__info">
            <div className="col-lg-4 board__section1">
              <div className="col-12">
                <p> <img src={user} alt="" srcset="" /> My Account</p>
                <p><img src={cart} alt="" srcset="" />Orders</p>
                <p><img src={saved} alt="" srcset="" /> Saved Items</p>
                <p><img src={messages} alt="" srcset="" /> Messages</p>
                <hr />
                <p>LOGOUT</p>
              </div>
            </div>
            <div className="col-lg-8 board__section2">
              <div className="col-12">
                <div className="board__section2__header">
                  <p >Account Overview</p>
                  <button>Edit</button>
                </div>

                <hr />
                <img src={userpic} alt="" />
                <p className="board__section2__name">DollyPee</p>
                <p className="board__section2__email">Oluwadolapor@gmail.com</p>
                <p className="board__section2__phone">08100083561</p>
                <p className="board__section2__address">via Awolowo Road/Ijebu Bypass/Liebu<br /> Bypass and Ogunmola Street/A1</p>
                <p>CHANGE PASSWORD</p>
              </div>
            </div>
          </div>
          <div className="Map">
            <img src={Map} alt="" srcset="" />
            <p>EDIT LOCATION </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default UserDashboard;